class JSAPI {
  refreshToken (uin, succCallback, errorCallback) {
    console.log('ready refreshToken'); 
    if (window.browser && window.browser.login && window.browser.login.refreshToken) {
      window.browser.login.refreshToken({
        uin: uin,
        appID: '116'
      }, (rst) => {
        console.log('refreshToken succ: ' + rst); 
        succCallback && succCallback(rst || {});
      });
    } else {
      console.log('refreshToken error: browser.login.refreshToken Not Exist!' ); 
      errorCallback && errorCallback(); 
    }
  } 
  /**
   * @desc 注册浏览器push
   *
   * @memberof JSAPI
   */
  QBPushRegister (qbid = '') {
    console.log('QBPushRegister qbid', qbid);
    if (window.browser && window.browser.app && window.browser.app.doTokenFeature) {
      console.log('do QBPushRegister');
      window.browser.app.doTokenFeature((rst) => {
        console.log('QBPushRegister', rst);
      }, {
        uid: qbid
      });
    } else {
      console.log('QBPushRegister not exists');
    }
  }
  /**
   * @desc 获取浏览器提供的参数，qua2
   */
  getQua2 () {
    console.log('getQua2 enter');
    return new Promise((resolve) => {      
      if (window.browser && window.browser.app && window.browser.app.getQua2) {
        window.browser.app.getQua2((qua) => {
          return resolve(qua);
        }, () => {
          return resolve('');
        });
      } else {
        return resolve('');
      }
    });
  }

  logoutAuthorizeInfo (succCallback, errorCallback) {
    console.log('ready logoutAuthorizeInfo');
    if (window.browser && window.browser.logoutAuthorizeInfo) {
      window.browser.logoutAuthorizeInfo((rst) => {
        console.log('logoutAuthorizeInfo succ: ' + rst); 
        succCallback && succCallback(rst || {});
      }, (rst) => {
        console.log('logoutAuthorizeInfo fail: ' + rst); 
        errorCallback && errorCallback(rst || {});
      }, {
        appID: '116'
      });
    } else {
      console.log('logoutAuthorizeInfo error: browser.logoutAuthorizeInfo Not Exist!' ); 
      errorCallback && errorCallback(); 
    }
  }
}

export default new JSAPI();